module.exports = __webpack_public_path__ + "img/es-MX.95033b0d.png";